module.exports = __webpack_public_path__ + "b6f49cb2d4c3a4262835f1d05a4e064a.pdf";